export interface OverallRows {
  thisYear: number | null;
  lastYear: number | null;
  yearOverYear: number | null;
}

export interface OverallColumns {
  storeVisits: OverallRows;
  omniRevenue: OverallRows;
  spend: OverallRows;
  omniReturnAdSpend: OverallRows;
}

export interface ROASGuaranteeRequirements {
  isEcommerce: boolean | null;
  isInStorePickUp: boolean | null;
  isGoogleBusinessProfile: boolean | null;
}

export interface ROASGuaranteeRequirementsMultiStore {
  multiStoreEcommerce: number | null;
  multiStoreInStorePickUp: number | null;
  multiStoreGoogleBusinessProfile: number | null;
}

export interface PerformanceLLMGrid {
  asOfDate: string;
  latestMonthly: OverallColumns;
  latestMonthlyDate: string;
  yearToDate: OverallColumns;
  yearToDateThruDate: string;
  roasRequirements: ROASGuaranteeRequirements | ROASGuaranteeRequirementsMultiStore;
  investment: number | null;
}

// ============================================================================
// MOCK DATA - FOR DEVELOPMENT/TESTING ONLY
// Replace this with actual API call in production.
// defaultPerformanceLLMGrid - data for store 3600
// defaultPerformanceLLMGridStore2 - data for store 7795
// ============================================================================
export const defaultPerformanceLLMGrid: PerformanceLLMGrid = {
  asOfDate: '2025-09-29',
  latestMonthly: {
    storeVisits: {
      thisYear: 1288,
      lastYear: 1456,
      yearOverYear: -11.5,
    },
    omniRevenue: {
      thisYear: 52323,
      lastYear: 54573,
      yearOverYear: -4.1,
    },
    spend: {
      thisYear: null,
      lastYear: null,
      yearOverYear: null,
    },
    omniReturnAdSpend: {
      thisYear: null,
      lastYear: null,
      yearOverYear: null,
    },
  },
  latestMonthlyDate: '2025-11-01',
  yearToDate: {
    storeVisits: {
      thisYear: 11472,
      lastYear: 12114,
      yearOverYear: -5.3,
    },
    omniRevenue: {
      thisYear: 440880,
      lastYear: 451376,
      yearOverYear: -2.3,
    },
    spend: {
      thisYear: 23901,
      lastYear: null,
      yearOverYear: null,
    },
    omniReturnAdSpend: {
      thisYear: 18.45,
      lastYear: null,
      yearOverYear: null,
    },
  },
  yearToDateThruDate: '2025-11-30',
  roasRequirements: {
    isEcommerce: true,
    isInStorePickUp: true,
    isGoogleBusinessProfile: true,
  },
  investment: 27160,
};

export const defaultPerformanceLLMGridStore2: PerformanceLLMGrid = {
  asOfDate: '2025-09-29',
  latestMonthly: {
    storeVisits: {
      thisYear: 806,
      lastYear: 638,
      yearOverYear: 26.4,
    },
    omniRevenue: {
      thisYear: 32711,
      lastYear: 26148,
      yearOverYear: 25.1,
    },
    spend: {
      thisYear: null,
      lastYear: null,
      yearOverYear: null,
    },
    omniReturnAdSpend: {
      thisYear: null,
      lastYear: null,
      yearOverYear: null,
    },
  },
  latestMonthlyDate: '2025-11-01',
  yearToDate: {
    storeVisits: {
      thisYear: 8427,
      lastYear: 8921,
      yearOverYear: -5.5,
    },
    omniRevenue: {
      thisYear: 327382,
      lastYear: 343949,
      yearOverYear: -4.8,
    },
    spend: {
      thisYear: 18181,
      lastYear: null,
      yearOverYear: null,
    },
    omniReturnAdSpend: {
      thisYear: 18.01,
      lastYear: null,
      yearOverYear: null,
    },
  },
  yearToDateThruDate: '2025-11-30',
  roasRequirements: {
    isEcommerce: false,
    isInStorePickUp: true,
    isGoogleBusinessProfile: true,
  },
  investment: 20660,
};

export const defaultPerformanceLLMGridChain: PerformanceLLMGrid = {
  asOfDate: '2025-09-29',
  latestMonthly: {
    storeVisits: {
      thisYear: 18329,
      lastYear: 14715,
      yearOverYear: 24.6,
    },
    omniRevenue: {
      thisYear: 910328,
      lastYear: 659658,
      yearOverYear: 38.0,
    },
    spend: {
      thisYear: null,
      lastYear: null,
      yearOverYear: null,
    },
    omniReturnAdSpend: {
      thisYear: null,
      lastYear: null,
      yearOverYear: null,
    },
  },
  latestMonthlyDate: '2025-11-01',
  yearToDate: {
    storeVisits: {
      thisYear: 153175,
      lastYear: 147133,
      yearOverYear: 7.5,
    },
    omniRevenue: {
      thisYear: 7211068,
      lastYear: 6677102,
      yearOverYear: 8.0,
    },
    spend: {
      thisYear: 245379,
      lastYear: null,
      yearOverYear: null,
    },
    omniReturnAdSpend: {
      thisYear: 29.39,
      lastYear: null,
      yearOverYear: null,
    },
  },
  yearToDateThruDate: '2025-11-30',
  roasRequirements: {
    multiStoreEcommerce: 14,
    multiStoreInStorePickUp: 15,
    multiStoreGoogleBusinessProfile: 15,
  },
  investment: 278840,
};
